module.exports = __webpack_public_path__ + "img/s2-1-ja.bd2b281d.jpg";